import { Component, Input } from '@angular/core';
import { CampoFiltroInterface } from '../../interfaces/campo-filtro.interface';

@Component({
  selector: 'app-filtros-lista',
  templateUrl: './filtros-lista.component.html',
  styleUrls: ['./filtros-lista.component.scss']
})
export class FiltrosListaComponent {

  @Input()
  public campos: CampoFiltroInterface[];

}
